import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBiv2m9TbkAyNikhECyH2MNxHnX9unbRvw",
  authDomain: "wingstop-69671.firebaseapp.com",
  projectId: "wingstop-69671",
  storageBucket: "wingstop-69671.firebasestorage.app",
  messagingSenderId: "1016649835305",
  appId: "1:1016649835305:web:0a08ad305068a7c1788d38",
  measurementId: "G-2LCVGCK5YS"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
